
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import Swal from 'sweetalert2';
import { getApi, postApi } from "../../Admin Master/Area Control/Zonemaster/ServicesApi";

function TrackingBooking() {
  const [getCustomer, setGetCustomer] = useState([]);
  const [toggleActive, setToggleActive] = useState(false);
  const [edit,setEdit]=useState(false);
  const [getMode, setGetMode] = useState([]);
  const [getDest, setGetDestination] = useState([]);
  const [getVendor, setGetVendor] = useState([]);
  const today = new Date();
  const [bookingDate, setBookingDate] = useState(today);
  const handleDateChange = (date) => {
    setBookingDate(date);
  };

  const onToggle = () => setToggleActive(!toggleActive);
  const [formData, setFormData] = useState({
    Customer_Code: JSON.parse(localStorage.getItem("Login"))?.Customer_Code,
    Branch_Code:JSON.parse(localStorage.getItem("Login"))?.Branch_Code,
    Origin_code: '',
    Destination_Code: '',
    Docket_No: '',
    Consignee_Name: '',
    Pcs: 0,
    ActualWt: 0,
    Mode_code: '',
    Vendor_Name: '',
    VendorAwbNo: '',
  });


  


  const allModeOptions = getMode.map(mode => ({ label: mode.Mode_Name, value: mode.Mode_Code }));
  const allVendorOptions = getVendor.map(Vendor => ({ label: Vendor.Vendor_Name, value: Vendor.Vendor_Code }));
  const allDesOptions = getDest.map(dest => ({ label: dest.City_Name, value: dest.City_Code }));
  const allCustomerOptions =
      Array.isArray(getCustomer) && getCustomer.length > 0
        ? getCustomer
          .map(cust => ({
            label: cust.Customer_Name,
            value: cust.Customer_Code.toString(),
            Branch_Code:cust.Branch_Code,
           
          }))
        : []

useEffect(()=>{

    setFormData((pre)=>({
      ...pre,
      Branch_Code:allCustomerOptions.find(op=>op.value===formData.Customer_Code)?.Branch_Code

    }))
  },[formData.Customer_Code])

 

  useEffect(() => {
    setBookingDate(new Date());
    const user = JSON.parse(localStorage.getItem("Login"));
    getApi(`/Master/getCustomerdata?Branch_Code=${user?.Branch_Code}&Customer_Code=${user?.Customer_Code}`).then(response => {
      if (response?.status === 1) setGetCustomer(response.Data);
    });
    getApi('/Master/getMode').then(response => {
      if (response?.status === 1) setGetMode(response.Data);
    });
    getApi('/Master/GetCityMast').then(response => {
      if (response?.status === 1) setGetDestination(response.Data);
      });
    getApi('/Master/getVendor').then(response => {
      if (response?.status === 1) setGetVendor(response.Data);  
    });
  }, []);

  const resetForm = () => {
    setFormData((prev) => ({
      ...prev,
    Origin_code: '',
    Destination_Code: '',
    Docket_No: '',
    Consignee_Name: '',
    Pcs: 0,
    ActualWt: 0,
    Mode_code: '',
    Vendor_Name: '',
    VendorAwbNo: '',
    }));
    setBookingDate(today);
    
  };
  const handleSave = async (e) => {
    e.preventDefault();
    if (!bookingDate) {
      Swal.fire('Error', 'BookDate is required.', 'error');
      return;
    }
    const payload = {
      docketNo: formData.Docket_No,
      bookDate: bookingDate ? bookingDate.toISOString().split("T")[0] : null,
      customerCode: formData.Customer_Code,
      consigneeName: formData.Consignee_Name,
      Vendor_Code: formData.Vendor_Name,
      VendorAwbno: formData.VendorAwbNo,
      modeCode: formData.Mode_code,
      originCode: formData.Origin_code,
      destinationCode: formData.Destination_Code,
      qty: formData.Pcs?.toString() || '0',
      actualWt: formData.ActualWt || "0",
      branchCode: formData?.Branch_Code,

    };
    try {
      const res = await postApi("/Booking/ShortBooking", payload);
      if (res.status === 1) {
        Swal.fire('Success', 'Booking saved successfully!', 'success').then(resetForm);
        resetForm();
      } else Swal.fire('Error', res.message, 'error');
    } catch (err) {
      Swal.fire('Error', 'Failed to save booking.', 'error');
      console.log(err);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const payload = {
      docketNo:formData.Docket_No,    
      BookDate: bookingDate ? new Date(bookingDate).toISOString().split('T')[0] : null,
      Customer_Code: formData.Customer_Code,
      Consignee_Name: formData.Consignee_Name,
      Vendor_Code: formData.Vendor_Name,
      VendorAwbno: formData.VendorAwbNo,
      Mode_code: formData.Mode_code,
      Origin_code: formData.Origin_code,
      Destination_Code: formData.Destination_Code,
      Qty: String(formData.Pcs),
      ActualWt: String(formData.ActualWt),
      Branch_Code: formData?.Branch_Code,
      ChargedWt:"0",
      ActualWt: String(formData.ActualWt),
      VolumetricWt:  '0',
      Rate: '0',
    };
    try {
      const res = await postApi(`/Booking/UpdateShortBooking?docketNo=${formData.Docket_No}`, payload);
      if (res.status === 1) {
        Swal.fire('Updated!', res.message || 'Booking updated.', 'success');
        resetForm();
      } else Swal.fire('Error', res.message || 'Update failed.', 'error');
    } catch (err) {
      Swal.fire('Error', 'Something went wrong while updating.', 'error');
      console.log(err);
    }
  };


  const handleSearch = async () => {
    if (!formData.Docket_No) return Swal.fire("Warning", "Enter Docket No", "warning");
    try {
      const res = await getApi(`/Booking/getShortBookingByDocketNo?DocketNo=${formData.Docket_No}`);
      if (res.status === 1 && res.data) {
        const data = res.data;
        setEdit(true);
        const customer = getCustomer.find(c => c.Customer_Code.toString() === data.Customer_Code);
        const mode = getMode.find(m => m.Mode_Code === data.Mode_code);
        const origin = getDest.find(c => c.City_Code === data.Origin_code);
        const destination = getDest.find(c => c.City_Code === data.Destination_Code);

        setFormData({
          Docket_No: data.DocketNo,
          Customer_Code: data.Customer_Code,
          Consignee_Name: data.Consignee_Name,
          VendorAwbNo:data.VendorAwbNo,
          Vendor_Name:data.Vendor_Code,
          Mode_code: data.Mode_code,
          Origin_code: data.Origin_code,
          Destination_Code: data.Destination_Code,
          Pcs: data.Qty,
          ActualWt: data.ActualWt,
          Branch_Code:data.Location_Code
        });

        setBookingDate(new Date(data.BookDate));
      } else {
        Swal.fire("Not Found", res.message || "Booking not found.", "info");
        setEdit(false);
      }
    } catch (err) {
      Swal.fire("Error", "Failed to fetch booking data.", "error");
      setEdit(false);
    }
  };

  const handleDelete = async (docketNo) => {
    if (!docketNo) return Swal.fire('Warning', 'Docket No is required', 'warning');

    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete booking with Docket No: ${docketNo}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#d33'
    });

    if (confirm.isConfirmed) {
      try {
        const res = await postApi(`/Booking/deleteShortBooking?docketNo=${docketNo}`);
        if (res.status === 1) {
          Swal.fire('Deleted!', res.message, 'success');
          resetForm();
        } else {
          Swal.fire('Error', res.message, 'error');
        }
      } catch (err) {
        Swal.fire('Error', 'Failed to delete booking.', 'error');
      }
    }
  };




  return (
    <>
      
      
        <div className='body'>
          <div className="container1" >
              <form onSubmit={(e) => e.preventDefault()} style={{backgroundColor:"white"}}>
                <div className="fields2">
                  <div className="input-field1">
                    <label>Customer</label>

                    <Select
                      className="blue-selectbooking"
                      classNamePrefix="blue-selectbooking"
                      options={allCustomerOptions}
                      value={formData.Customer_Code ? allCustomerOptions.find(opt => opt.value === formData.Customer_Code) : null}
                      onChange={(selectedOption) => {
                        setFormData(prev => ({
                          ...prev,
                          Customer_Code: selectedOption.value,
                          Customer_Name: selectedOption.label
                        }));
                      }}
                      placeholder="Select Customer"
                      menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                      }}
                    />
                  </div>

                  <div className="input-field1">
                    <label>Booking Date</label>
                    <DatePicker
                      selected={bookingDate}
                      onChange={(date) => handleDateChange(date)}
                      dateFormat="dd/MM/yyyy"
                      
                      wrapperClassName="w-100"
                    />
                  </div>

                  <div className="input-field1">
                    <label>Mode</label>
                    <Select
                      className="blue-selectbooking"
                      classNamePrefix="blue-selectbooking"
                      options={allModeOptions}
                       value={formData.Mode_code ? allModeOptions.find(opt => opt.value === formData.Mode_code) : null}
                      
                      onChange={(selected) => {
                        setFormData(prev => ({
                          ...prev,
                          Mode_code: selected?.value || ''
                        }));
                      }}
                      placeholder="Select Mode"
                      menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                      }}
                    />
                  </div>

                  <div className="input-field1">
                    <label>Docket No</label>
                    <div className="docket-wrapper">
                            <input
                                type="text"
                                className="input"
                                placeholder={toggleActive ? "Enter Docket No" : "Auto Booking On"}
                                disabled={!toggleActive}
                                value={formData.Docket_No}
                                onChange={async (e) => {
                                    const value = e.target.value;
                    
                                    setFormData(prev => ({
                                        ...prev,
                                        Docket_No: value
                                    }));
                    
                                    // Your API code...
                                }}
                            />
                    
                            <Toggle className="react-toggle"
                                checked={toggleActive}
                                onChange={() => setToggleActive(prev => !prev)}
                                tabIndex={-1}
                            />
                        </div>

                    
                  </div>

                 

                  <div className="input-field1">
                    <label>Consignee Name</label>
                    <input type="text" placeholder='Consignee Name' className="input" value={formData.Consignee_Name} onChange={(e) => setFormData({ ...formData, Consignee_Name: e.target.value })} />
                  </div>

                  <div className="input-field1">
                    <label>Vendor Name</label>
                     <Select
                      className="blue-selectbooking"
                      classNamePrefix="blue-selectbooking"
                      options={allVendorOptions}
                      value={formData.Vendor_Name ? allVendorOptions.find(opt => opt.value === formData.Vendor_Name) : null}
                      onChange={(selected) => {
                        setFormData(prev => ({
                          ...prev,
                          Vendor_Name: selected?.value || ''
                        }));
                      }}
                      placeholder="Select Vendor"
                      menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                      }}
                    />
                  </div>

                  <div className="input-field1">
                    <label>Vendor Awb No</label>
                    <input type="text" placeholder='Vendor Awb No' className="input" value={formData.VendorAwbNo} onChange={(e) => setFormData({ ...formData, VendorAwbNo: e.target.value })} />
                  </div>

                 

                  <div className="input-field1">
                    <label>Origin</label>
                    <Select
                      className="blue-selectbooking"
                      classNamePrefix="blue-selectbooking"
                      options={allDesOptions}
                      value={formData.Origin_code ? allDesOptions.find(opt => opt.value === formData.Origin_code) : null}
                      onChange={(selected) => {
                        
                        setFormData({ ...formData, Origin_code: selected?.value || '' });
                      }}
                      placeholder="Select Origin"
                      menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                      }}
                    />
                  </div>

                  



                  <div className="input-field1">
                    <label>Destination</label>
                    <Select
                      className="blue-selectbooking"
                      classNamePrefix="blue-selectbooking"
                      options={allDesOptions}
                      value={formData.Destination_Code ? allDesOptions.find(opt => opt.value === formData.Destination_Code) : null}
                      onChange={(selected) => {
                       
                        setFormData({ ...formData, Destination_Code: selected?.value || '' });
                      }}
                      placeholder="Select Destination"
                      menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll container
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps dropdown on top
                      }}
                    />
                  </div>

                  <div className="input-field3">
                    <label>Pcs</label>
                    <input
                      type="number"
                      placeholder="Pcs"
                      className="input"
                      value={formData.Pcs}
                      onChange={(e) => setFormData({ ...formData, Pcs: e.target.value })}
                    />
                  </div>

                 

                  <div className="input-field3">
                    <label>Actual Weight</label>
                    <input type="number" min="0" className="input" value={formData.ActualWt} onChange={(e) => setFormData({ ...formData, ActualWt: e.target.value })} />
                  </div>


                  

                 

                  <div className="row g-2 justify-content-center w-100">
  {
    !edit ? <div className="col-6 col-sm-6 col-md-3 col-lg-2 custom-save-button">
    <button className="btn btn-success w-100" onClick={handleSave}>
      Save
    </button>
  </div>
:
  <div className="col-6 col-sm-6 col-md-3 col-lg-2 custom-save-button">
    <button
      type="button"
      className="btn btn-primary w-100"
      onClick={handleUpdate}
    >
      Update
    </button>
  </div>
}

  <div className="col-6 col-sm-6 col-md-3 col-lg-2 custom-save-button">
    <button
      type="button"
      className="btn btn-warning w-100"
      onClick={handleSearch}
    >
      Search
    </button>
  </div>

  <div className="col-6 col-sm-6 col-md-3 col-lg-2 custom-save-button">
    <button
      type="button"
      className="btn btn-danger w-100"
      onClick={() => handleDelete(formData.Docket_No)}
    >
      Delete
    </button>
  </div>
</div>
                </div>


                

              </form>
              
            
          </div>
        </div>
        

    </>
  );
}

export default TrackingBooking;
